// Monthly Workout Library - Organized by subscription months
// This prevents the workout list from becoming too long by organizing content monthly

const monthlyWorkouts = {
  // Month 1 - Back to Basics Foundation
  1: {
    month: 1,
    theme: "The Classics",
    title: "The Classics",
    description: "Build your fitness foundation with fundamental movement patterns",
    focusAreas: ["Strength", "Balance", "Mobility"],
    difficulty: "beginner",
    estimatedDuration: 30,
    
    // Back to Basics Challenge (7 days)
    dailyChallenge: [
      {
        day: 1,
        title: "DAY 1 – SQUAT",
        movement: "Bodyweight Squat",
        description: "Welcome to Day 1 of the Back to Basics Challenge — we're starting strong with one of the most foundational movement patterns your body can master: the squat.\n\nYou don't need a gym or fancy equipment to build real strength — just intention, form, and consistency. This move powers up your legs, your glutes, and your confidence from the ground up.",
        whyItMatters: "Squats show up everywhere — when you sit down, get back up, lift a box, chase your kids, or pick up groceries. This isn't just a workout move. It's a real-life strength tool.",
        instructions: "Feet about hip-width apart, chest lifted, weight in your heels. Sink back and down like you're sitting in a chair — then drive through your legs to stand tall. Go slow. Own every rep.",
        workout: "Bodyweight Squats – 40 seconds\nRest – 20 seconds\n→ Repeat 2–3x\n\n(Doesn't seem like much today … enjoy that! You'll build on this each day as we stack new movement patterns into your workout! You'll be at 7 moves by the end)",
        formTip: "Think hips back, heels down, chest proud. If you're unsure of depth, squat to a chair or box to groove the pattern.",
        dailyWin: "Drop a 🔥 or 'DONE' below when you finish. Then tell us: 👉 Where do YOU squat most often in everyday life? Kitchen? Kids? Car? Couch? Let's name those real-world strong moments.\n\nEvery strong move starts somewhere. This is yours. Let's go.",
        videoId: '0bc675880b5400d89eedf9e854e7ee96',
        platform: 'cloudflare',
        focusAreas: ["Legs", "Core", "Balance"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 2,
        title: "DAY 2 - HINGE",
        movement: "Hip Hinge (aka your Deadlift foundation)",
        description: "Today's Movement: Hip Hinge (aka your Deadlift foundation)\n\nStand tall with a soft bend in your knees.\nPush your hips back like you're closing a car door behind you with your butt.\nKeep your spine long and your core tight … then return to standing.\n\n👉 This is the foundation of every good deadlift.\n\nEven without weights, this pattern builds strength, stability, and glute power.",
        whyItMatters: "This is the foundation of every good deadlift. Even without weights, this pattern builds strength, stability, and glute power.",
        instructions: "Stand tall with a soft bend in your knees. Push your hips back like you're closing a car door behind you with your butt. Keep your spine long and your core tight … then return to standing.",
        workout: "Bodyweight Squats (from Day 1) – 40 sec\nDeadlifts (Hip Hinges) – 40 sec\nRest – 20 sec\n→ Repeat 2–3x",
        formTip: "Your hips move … not your knees. Keep the weight in your heels and your spine neutral. You should feel this in your glutes + hamstrings, not your low back.",
        dailyWin: "Drop a ✅ or 🔥 when you finish. Then tell us: 👉 What's something you picked up this week where a strong hinge could've helped? A bag? A laundry basket? A plant? Name it.\n\nYou're not just building strength … you're building awareness. Keep stacking. Keep showing up. You're on your way.",
        videoId: 'd39afad8277362e560582c6d487c7b80',
        platform: 'cloudflare',
        focusAreas: ["Glutes", "Hamstrings", "Core"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 3,
        title: "DAY 3 – LUNGE: Balance + Control",
        movement: "Reverse Lunge",
        description: "Welcome to Day 3 of the Back to Basics Challenge … today's all about control, coordination, and single-leg strength.\nLunges challenge your lower body and your focus.\nThey're less about going heavy … and more about moving with purpose.",
        whyItMatters: "You lunge every time you go up stairs, kneel down, split your stance, or shift your weight from one leg to the other. Training this pattern builds not just strength, but confidence and stability in movement … especially when life doesn't happen on two perfectly balanced feet.",
        instructions: "Step one foot back into a deep lunge. Front knee stacked over ankle, back knee drops toward the floor. Press through the front heel to return to standing. Keep your chest proud and core tight … and alternate sides each rep.",
        workout: "Bodyweight Squats (Day 1) – 40 sec\nHip Hinges / Deadlifts (Day 2) – 40 sec\nReverse Lunges – 40 sec\nRest – 20 sec\n→ Repeat 2–3x",
        formTip: "Think down not back … keep your front heel grounded and your hips square. Slower is stronger.",
        dailyWin: "Drop a 🔥 when you finish! Then tell us: 👉 What required more focus today … balance or strength? We're building both.\n\nYou've now stacked 3 of the most important movement patterns your body can master. That's not basic … that's power.",
        videoId: 'a5b18eb799f63f2a7576370415184bee',
        platform: 'cloudflare',
        focusAreas: ["Legs", "Balance", "Coordination"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 4,
        title: "DAY 4 – PUSH: Strong Arms, Strong You",
        movement: "Incline Push-Up (or Floor Push-Up)",
        description: "It's Day 4 of the Back to Basics Challenge … and today we're moving into upper-body territory with one of the most empowering patterns: the push.\n\nThink push-ups, presses, overhead reach … moves that build muscle, shape your shoulders, and help you move with strength and ease.",
        whyItMatters: "Every time you push a door open, press overhead, or get up off the floor … you're using this pattern. When trained properly, push strength builds upper-body control, improves posture, and helps you trust your strength.",
        instructions: "Hands on a bench, couch, or wall … or take it to the floor. Lower slowly with control, elbows at about 45°, core tight, hips in line. Press back up strong and proud. Choose the level that challenges you without breaking form.",
        workout: "Squats (Day 1) – 40 sec\nHip Hinges / Deadlifts (Day 2) – 40 sec\nReverse Lunges (Day 3) – 40 sec\nIncline or Floor Push-Ups – 40 sec\nRest – 20 sec\n→ Repeat 2–3x",
        formTip: "Think of your whole body as a moving plank. Lower with control, exhale on the press … and if you're new to this, incline is gold.",
        dailyWin: "Drop a 💪 when you finish! Then tell us: 👉 What did you choose today … incline or floor? How did it feel? This is YOUR strength story.\n\nStrong arms = strong boundaries, strong lifts, and strong self-belief. Own it.",
        videoId: '99d78465a8219038d64c193dc0f24084',
        platform: 'cloudflare',
        focusAreas: ["Chest", "Arms", "Core"],
        equipment: ["Wall", "Bench", "Floor"],
        difficulty: "beginner"
      },
      {
        day: 5,
        title: "DAY 5 – PULL: Back It Up",
        movement: "Bent-Over Row (or Band Row)",
        description: "It's Day 5 of the Back to Basics Challenge … and today, we're training one of the most underrated (but most game-changing) movement patterns: the pull.\nPush gets all the hype … but pull is what balances your body, improves your posture, and gives you strength where it actually counts.",
        whyItMatters: "You pull every time you open a door, grab groceries, pick something up, or row a paddle or suitcase. Strong pulling muscles = strong posture, better shoulder health, and fewer injuries. Most people skip it. You're not most people.",
        instructions: "Hold dumbbells or a band. Hinge at the hips, soft bend in the knees, spine long. Pull elbows back toward your hips — pause — then lower with control. Keep your core tight and shoulder blades squeezing together.",
        workout: "Squats (Day 1) – 40 sec\nHip Hinges / Deadlifts (Day 2) – 40 sec\nReverse Lunges (Day 3) – 40 sec\nIncline or Floor Push-Ups (Day 4) – 40 sec\nBent-Over Rows (or Band Rows) – 40 sec\nRest – 20 sec\n→ Repeat 2–3x",
        formTip: "Think: chest open, elbows drive back, core stays tight. It's not a shrug — it's a pull. Keep it clean.",
        dailyWin: "Drop a 🔷 when you finish! Then tell us: 👉 How's your posture feeling this week? Anything feel stronger already?\n\nThis is the work most people skip. You're building strength from the back forward … and that changes everything.",
        videoId: 'bd4e22ce9d95997beded97dcb7c66089',
        platform: 'cloudflare',
        focusAreas: ["Back", "Posture", "Shoulders"],
        equipment: ["Dumbbells", "Resistance Band"],
        difficulty: "beginner"
      },
      {
        day: 6,
        title: "DAY 6 – CORE & ROTATION: Power from the Center",
        movement: "Dead Bug (Anti-Rotation Core Control)",
        description: "It's Day 6 of the Back to Basics Challenge … and today we're training one of the most essential (and overlooked) movement skills: Rotation … and its secret twin, anti-rotation.\nRotation is more than just twisting. It's your body's ability to move through your spine or stay stable under load when something tries to pull you off-center. And it's one of the most important skills for injury prevention, real-life strength, and total-body coordination.",
        whyItMatters: "You rotate every time you reach across the car, throw something, swing a bag over your shoulder, or twist to grab the dog leash. But here's the kicker … your core has to decide when to twist… and when to resist. Today, we train both … starting with anti-rotation, the foundation for all powerful, safe movement.",
        instructions: "Lie on your back, arms extended above your chest, knees bent in tabletop. Extend opposite arm and leg slowly, then return to center. Switch sides. Your job is to keep your hips and ribs stable … no wobbling, no tipping. This teaches your body to resist twist … and build stability that shows up everywhere else.",
        workout: "Squats (Day 1) – 40 sec\nHip Hinges / Deadlifts (Day 2) – 40 sec\nReverse Lunges (Day 3) – 40 sec\nIncline or Floor Push-Ups (Day 4) – 40 sec\nBent-Over Rows / Band Rows (Day 5) – 40 sec\nDead Bug – 40 sec\nRest – 20 sec\n→ Repeat 1–2x (optional 3rd round)",
        formTip: "Keep your low back gently pressed into the floor. Ribs down. Core engaged. Slower = better. You're not just moving — you're resisting.",
        dailyWin: "Drop a 🌀 when you finish! Then tell us: 👉 Where in life do you think your core shows up most? (Twisting, lifting, balancing — name your moment!)\n\nRotation is one of the most powerful forces in your body. Today you didn't just move through it — you owned it.",
        videoId: '88272d9a5cb1a302cfbf3c8bec5dcfd3',
        platform: 'cloudflare',
        focusAreas: ["Core", "Stability", "Anti-Rotation"],
        equipment: ["Mat"],
        difficulty: "beginner"
      },
      {
        day: 7,
        title: "DAY 7 – WALK IT OUT: Strength in Motion",
        movement: "Loaded March or Farmer's Carry",
        description: "You did it … it's Day 7 of the Back to Basics Challenge, and today we're integrating everything you've built this week. This final movement pattern is what ties it all together:\n\nGait. Carry. Balance. Presence.\nWe're not doing reps today just to say we did them.\nWe're practicing how to move with intention, posture, and confidence … because strength isn't just what you lift, it's how you walk through life.",
        whyItMatters: "Every step you take is a transfer of strength, stability, and control. Walking is one of the most functional, foundational, and underrated patterns we use — every single day. Add in a load? You've got a full-body training tool that builds grip, core, posture, and real-world power.",
        instructions: "Hold one or two dumbbells (or go bodyweight). Stand tall. Core tight. Shoulders pulled back. March in place or walk forward slowly … without wobble or rush. This is not a stroll. It's a posture rep. Bonus: Use one weight for an offset carry to challenge your core and balance even more.",
        workout: "Squats (Day 1) – 40 sec\nHip Hinges / Deadlifts (Day 2) – 40 sec\nReverse Lunges (Day 3) – 40 sec\nPush-Ups (Day 4) – 40 sec\nRows / Band Pulls (Day 5) – 40 sec\nDead Bug (Anti-Rotation) (Day 6) – 40 sec\nLoaded March or Carry (Day 7) – 40 sec\nRest – 20 sec\n→ Repeat 2–3x (your call — this is your graduation!)",
        formTip: "Don't just walk … own the space you take up. Stand tall. Eyes forward. Shoulders proud. Let every step remind you that you're moving through life stronger than when you started.",
        dailyWin: "Drop a 🏁 when you're done! Then tell us: 👉 What's been your biggest personal win from this challenge … in your body or in your mindset? Let's celebrate it.\n\nYou didn't just complete 7 workouts. You built a foundation. You showed up. You moved with purpose. You're ready.\n\n🎯 Next step: The Classic 7\nYou've got the patterns. Now let's build the strength.",
        videoId: '9b42997a90ffcef2b8d80c520e029e62',
        platform: 'cloudflare',
        focusAreas: ["Full Body", "Posture", "Grip"],
        equipment: ["Dumbbells", "None"],
        difficulty: "beginner"
      }
    ],

    // Workout of the Week (WOW) - 4 weeks
    workoutOfTheWeek: [
      {
        week: 1,
        title: "Foundation Strength Circuit",
        description: "Build your base strength with fundamental movements",
        cloudflareStreamId: "0bc675880b5400d89eedf9e854e7ee96",
        duration: 1200, // 20 minutes
        difficulty: "beginner",
        focusAreas: ["Strength", "Balance", "Coordination"],
        equipment: ["None", "Chair"],
        exercises: [
          {
            name: "Chair Squats",
            sets: 3,
            reps: 10,
            restSeconds: 60,
            focusAreas: ["Legs", "Core"]
          },
          {
            name: "Wall Push-ups",
            sets: 3,
            reps: 12,
            restSeconds: 45,
            focusAreas: ["Chest", "Arms"]
          },
          {
            name: "Seated Leg Raises",
            sets: 2,
            reps: 8,
            restSeconds: 30,
            focusAreas: ["Core", "Legs"]
          }
        ]
      },
      {
        week: 2,
        title: "Balance & Stability Focus",
        description: "Improve your balance and stability with targeted exercises",
        cloudflareStreamId: "a5b18eb799f63f2a7576370415184bee",
        duration: 1500, // 25 minutes
        difficulty: "beginner",
        focusAreas: ["Balance", "Stability", "Coordination"],
        equipment: ["None", "Wall"],
        exercises: [
          {
            name: "Single Leg Stands",
            sets: 3,
            reps: 30,
            restSeconds: 30,
            focusAreas: ["Balance", "Core"]
          },
          {
            name: "Heel-to-Toe Walk",
            sets: 2,
            reps: 10,
            restSeconds: 45,
            focusAreas: ["Balance", "Coordination"]
          },
          {
            name: "Side Leg Raises",
            sets: 2,
            reps: 8,
            restSeconds: 30,
            focusAreas: ["Hips", "Balance"]
          }
        ]
      },
      {
        week: 3,
        title: "Upper Body Strength",
        description: "Build upper body strength with progressive exercises",
        cloudflareStreamId: "99d78465a8219038d64c193dc0f24084",
        duration: 1800, // 30 minutes
        difficulty: "intermediate",
        focusAreas: ["Upper Body", "Core", "Posture"],
        equipment: ["Resistance Band", "Dumbbells"],
        exercises: [
          {
            name: "Band Rows",
            sets: 3,
            reps: 12,
            restSeconds: 60,
            focusAreas: ["Back", "Posture"]
          },
          {
            name: "Arm Circles",
            sets: 2,
            reps: 15,
            restSeconds: 30,
            focusAreas: ["Shoulders", "Mobility"]
          },
          {
            name: "Overhead Press",
            sets: 3,
            reps: 8,
            restSeconds: 60,
            focusAreas: ["Shoulders", "Core"]
          }
        ]
      },
      {
        week: 4,
        title: "Full Body Integration",
        description: "Put it all together with a comprehensive full-body workout",
        cloudflareStreamId: "9b42997a90ffcef2b8d80c520e029e62",
        duration: 2100, // 35 minutes
        difficulty: "intermediate",
        focusAreas: ["Full Body", "Endurance", "Coordination"],
        equipment: ["Dumbbells", "Resistance Band"],
        exercises: [
          {
            name: "Squat to Overhead Press",
            sets: 3,
            reps: 8,
            restSeconds: 90,
            focusAreas: ["Full Body", "Coordination"]
          },
          {
            name: "Farmer's Carry",
            sets: 3,
            reps: 20,
            restSeconds: 60,
            focusAreas: ["Full Body", "Grip", "Posture"]
          },
          {
            name: "Dead Bug",
            sets: 2,
            reps: 10,
            restSeconds: 45,
            focusAreas: ["Core", "Stability"]
          }
        ]
      }
    ],

    // Monthly Challenge
    monthlyChallenge: {
      title: "30-Day Movement Challenge",
      description: "Complete at least 10 minutes of movement every day for 30 days",
      goal: "Build consistency and establish healthy habits",
      rules: [
        "Complete at least 10 minutes of intentional movement daily",
        "Can be any form of exercise: walking, stretching, strength training",
        "Track your progress in the app",
        "Share your wins with the community"
      ],
      rewards: [
        "Improved energy levels",
        "Better sleep quality",
        "Increased strength and mobility",
        "Community recognition badge"
      ],
      cloudflareStreamId: "0bc675880b5400d89eedf9e854e7ee96",
      isActive: true
    },

    // Elite Guided Videos - Month 1
    eliteGuidedVideos: {
      title: "Elite Month 1 - Guided Workout Videos",
      description: "Professional guided workout videos with expert instruction",
      tier: "elite",
      videos: [
        {
          id: "elite-monday-classics",
          day: "Monday",
          title: "The Classics",
          description: "Master the fundamental movement patterns with expert guidance",
          duration: 39.6167, // minutes
          durationSeconds: 2377,
          displayDuration: "39:37",
          difficulty: "intermediate",
          focusAreas: ["Strength", "Form", "Foundation"],
          equipment: ["Dumbbells", "Resistance Band"],
          videoId: "a9cd390a08867b09f493e6f63d0ad9ac",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762953564/1_zu36hh.png",
          exercises: [
            "Squat Variations",
            "Hip Hinge Patterns", 
            "Push Movements",
            "Pull Movements",
            "Core Stability"
          ]
        },
        {
          id: "elite-tuesday-upper",
          day: "Tuesday", 
          title: "Upper Classics",
          description: "Focus on upper body strength and posture with guided instruction",
          duration: 29.1333, // minutes
          durationSeconds: 1748,
          displayDuration: "29:08",
          difficulty: "intermediate",
          focusAreas: ["Upper Body", "Posture", "Shoulder Health"],
          equipment: ["Dumbbells", "Resistance Band"],
          videoId: "ee15caf3e083f8d8c6cb80911564536f",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762953564/2_yzpziz.png",
          exercises: [
            "Push-up Variations",
            "Row Patterns",
            "Shoulder Press",
            "Lateral Raises",
            "Posture Corrections"
          ]
        },
        {
          id: "elite-wednesday-core",
          day: "Wednesday",
          title: "Core Classics Banded Up", 
          description: "Advanced core training with resistance bands for enhanced strength",
          duration: 27.9, // minutes
          durationSeconds: 1674,
          displayDuration: "27:54",
          difficulty: "intermediate",
          focusAreas: ["Core", "Stability", "Anti-Rotation"],
          equipment: ["Resistance Band", "Mat"],
          videoId: "4ce78b256d654ab2f6f7ca511da675cc",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762953564/3_w4skqc.png",
          exercises: [
            "Banded Dead Bug",
            "Banded Pallof Press",
            "Banded Wood Chops",
            "Banded Plank Variations",
            "Anti-Rotation Holds"
          ]
        },
        {
          id: "elite-thursday-stretch",
          day: "Thursday",
          title: "Classic Stretch & Strength",
          description: "Combine flexibility and strength for optimal movement quality",
          duration: 16.8167, // minutes
          durationSeconds: 1009,
          displayDuration: "16:49",
          difficulty: "intermediate", 
          focusAreas: ["Flexibility", "Mobility", "Strength"],
          equipment: ["Resistance Band", "Mat", "Dumbbells"],
          videoId: "51fd33989531e1a8ee2383ff10b3f031",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762953564/4_flqbhz.png",
          exercises: [
            "Dynamic Warm-up",
            "Strength Movements",
            "Active Stretching",
            "Mobility Drills",
            "Cool-down Stretches"
          ]
        },
        {
          id: "elite-friday-finisher",
          day: "Friday",
          title: "The Finisher",
          description: "High-intensity finisher to cap off your week with energy",
          duration: 40.6333, // minutes
          durationSeconds: 2438,
          displayDuration: "40:38",
          difficulty: "intermediate",
          focusAreas: ["Cardiovascular", "Endurance", "Full Body"],
          equipment: ["Dumbbells", "Resistance Band"],
          videoId: "384abd77a3709821afbcd7615631477e",
          platform: "cloudflare", 
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762953564/5_jnjj4s.png",
          exercises: [
            "Circuit Training",
            "Compound Movements",
            "Cardio Bursts",
            "Full Body Integration",
            "Cool-down"
          ]
        }
      ]
    }
  },

  // Month 2 - Progressive Strength
  2: {
    month: 2,
    theme: "Fight School",
    title: "Fight for Your Fitness",
    description: "A 7-day journey to build strength, confidence, and a fighter's mindset - adapted for seniors who want to fight for their health and independence.\n\nFight School isn't about combat - it's about developing the mental and physical strength to tackle life's challenges with confidence. These movements build the balance, coordination, and power you need to maintain independence, prevent falls, and stay strong for the activities you love.\n\nEvery exercise is designed with seniors in mind: safe, effective, and focused on real-world benefits like climbing stairs, lifting groceries, maintaining balance, and staying active in your golden years.",
    focusAreas: ["Strength", "Balance", "Confidence", "Coordination"],
    difficulty: "intermediate",
    estimatedDuration: 35,

    // Daily Challenge - Fight School adapted for seniors
    dailyChallenge: [
      {
        day: 1,
        title: "DAY 1 – STANCE + JAB-CROSS FOUNDATIONS",
        movement: "Fighter Stance + Controlled Punches",
        description: "Welcome to FIGHT SCHOOL 🥊 … your 7-day journey to move with confidence, build real strength, and fight for the goals that matter most to YOU.\n\nEvery fighter starts with the basics: stance + jab + cross. If you get these down, everything else becomes easier. For seniors, this builds balance, coordination, and the confidence to tackle daily challenges.\n\nWhy Fight School for Seniors? These movements aren't about combat - they're about building the strength, balance, and mental toughness you need to maintain independence, prevent falls, and stay active. A strong stance prevents falls. Controlled movements build coordination. The fighter's mindset gives you confidence to tackle any challenge life throws your way.",
        whyItMatters: "A strong stance builds balance and stability - essential for preventing falls. Controlled punching movements develop upper body strength, coordination, and confidence. These movements translate to everyday activities like reaching, lifting, and maintaining independence.\n\nFor seniors, this foundation is crucial: a stable stance helps you get up from chairs safely, walk confidently, and maintain balance on uneven surfaces. The coordination you build here helps with everything from cooking to gardening to playing with grandchildren.",
        instructions: "Step 1: Find Your Stance - Left foot forward, right foot back (or opposite if left-handed). Keep knees soft, heels light, and hands up at guard. Step 2: Practice torso rotation - rotate left and right while keeping guard up. Step 3: Jab-Cross combo - Front hand quick snap straight out and back, then back hand with torso rotation. Always bring hands back to guard.",
        workout: "3 Rounds (2 minutes each)\n30 sec Torso rotations with guard up (warm-up)\n30 sec Jab-Cross combo (controlled speed)\n30 sec Lunge Cross (adding legs = power)\n30 sec SPEED Jab-Cross with rotation (feel it in the core)",
        formTip: "Think down not back … keep your front heel grounded and your hips square. Slower is stronger. Focus on control over speed.",
        dailyWin: "Drop a 🥊 if you nailed Day 1! Strong stance. Core rotation. Guard up. That's your foundation for fighting for your fitness.",
        videoId: 'ce383942df09ffbc1558e7d4fc86306f',
        platform: 'cloudflare',
        focusAreas: ["Balance", "Coordination", "Upper Body Strength"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 2,
        title: "DAY 2 – HOOKS + UPPERCUTS (UNLEASH THE POWER)",
        movement: "Power Punches with Control",
        description: "Day 1 was all about foundation … stance, guard, rotation, and the jab-cross.\n\nToday, we step it up with the power shots: the Hook and the Uppercut. These movements aren't about speed … they're about torque, power, and putting your whole body behind the movement. When you throw these right, you'll feel unstoppable.",
        whyItMatters: "Hooks and uppercuts build rotational strength and core power - essential for maintaining balance and preventing falls. These movements strengthen the muscles that help you twist, turn, and maintain stability in daily activities.",
        instructions: "The Hook: Lead with your front hand, elbow at shoulder height, arm bent at 90°. Rotate your torso and hips as you swing across. The Uppercut: Start in stance, knees soft. Drop slightly, then drive your fist upward. Power comes from your legs + core. Keep your other hand guarding your face.",
        workout: "3 Rounds (2 minutes each)\n30 sec F Hooks (controlled - F = from the front)\n30 sec Uppercuts (driven from legs + core R then F)\n30 sec Squat Uppercut\n30 sec Hook + Uppercut combo (flow between the two)",
        formTip: "Power comes from the ground up. Strong legs + strong core = powerful movements. Focus on feeling the rotation and driving through your core.",
        dailyWin: "Drop a 💪 when you finish! Which felt more powerful for you … the hook or the uppercut? You're building strength that shows up everywhere.",
        videoId: '6a211425844b14cecc0a28607adec621',
        platform: 'cloudflare',
        focusAreas: ["Core Strength", "Rotational Power", "Balance"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 3,
        title: "DAY 3 – SLIP + ROLL (DEFENSE WINS FIGHTS)",
        movement: "Defensive Movements & Balance",
        description: "We've been throwing punches like champs … jab, cross, hooks, uppercuts.\n\nBut a true fighter knows: it's not just about how hard you hit … It's about how well you can defend and stay in the fight. That's where today's moves come in: the Slip and the Roll.",
        whyItMatters: "Defensive movements build reactive balance and agility - crucial for preventing falls and maintaining independence. Learning to move and recover quickly helps you stay safe and confident in daily life.",
        instructions: "The Slip: Start in stance, guard high. Imagine a punch coming straight at your nose. Rotate and tilt your torso just enough to let it 'slip' past. Keep your eyes forward. The Roll: Start in stance, knees bent. Imagine a hook coming toward the side of your head. Bend your knees and draw a 'U' shape with your head and shoulders as you roll under. Stay tight, keep your guard up.",
        workout: "3 Rounds (2 minutes each)\n30 sec Slip side-to-side (with guard high)\n30 sec Roll under (U-shaped squat + rotation)\n30 sec Jab-Cross + R Slip (throw the combo, then slip)\n30 sec F Hook + Roll to front (hook punch, then roll under)",
        formTip: "Defense is all about control. Small, sharp, efficient movements. Think: squat + rotation, not a full bend-over.",
        dailyWin: "Drop a 🛡️ when you finish! Defense wins fights … what helps YOU bounce back when life throws challenges?",
        videoId: 'ff54a33f5bd67accbf480e3b9d6910ba',
        platform: 'cloudflare',
        focusAreas: ["Balance", "Reaction Time", "Core Stability"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 4,
        title: "DAY 4 – KNEES + FRONT KICKS (LEG POWER UNLEASHED)",
        movement: "Lower Body Power & Stability",
        description: "You've built your foundation, learned to throw with power, and practiced staying in control with defense.\n\nToday, it's time to bring in your strongest weapons: your legs. Knees and front kicks aren't just about striking … they're about DRIVE, about fighting forward for your goals.",
        whyItMatters: "Leg power and stability are essential for maintaining independence. Strong legs help you climb stairs, get up from chairs, and maintain balance. These movements build the strength you need for daily activities.",
        instructions: "The Knee Drive: From stance, guard high. Push off your front foot and drive your rear knee forward and up. As you thrust, lean slightly back and pull your arms down. Land back softly into stance. The Front Kick: From stance, guard up. Lift your front knee first, then snap your foot out like you're pushing a heavy door. Aim with the ball of your foot, not your toes. Retract it fast and land back in stance.",
        workout: "3 Rounds (2 minutes each)\n30 sec Alternating Knee Drives (sharp + controlled)\n30 sec Front Kicks (switch legs)\n30 sec R knee, switch feet, Front kick\n30 sec Cross-Jab + R Knee (hands and legs working together)\n30 sec F Uppercut, R Hook + Front Kick (flow combo)",
        formTip: "Your legs are your powerhouse. When life pushes back, drive forward … stronger, steadier, unstoppable. Focus on control and balance.",
        dailyWin: "Drop a 🦵 when you finish! If life's in your way … are you driving through it or kicking it down?",
        videoId: '4eb1dac2857254045105e38234b1cb65',
        platform: 'cloudflare',
        focusAreas: ["Leg Strength", "Balance", "Coordination"],
        equipment: ["None"],
        difficulty: "beginner"
      },
      {
        day: 5,
        title: "DAY 5 – SIDE KICK + BACK KICK (BALANCE + CONTROL)",
        movement: "Advanced Balance & Precision",
        description: "By now you've thrown jabs, crosses, hooks, uppercuts … slipped and rolled … powered through knees and front kicks. You're starting to feel like a fighter.\n\nToday we level up with Side Kicks and Back Kicks … movements that demand balance, control, and precision. These moves aren't wild flails; they're laser-focused, powerful, and steady.",
        whyItMatters: "Advanced balance movements challenge your stability and coordination - essential skills for preventing falls and maintaining independence. These movements build the confidence to tackle any physical challenge.",
        instructions: "The Side Kick: From stance, pivot slightly so your body is angled side-on. Lift your knee, then extend your heel out to the side. Lean your upper body slightly away as you kick to stay balanced. Retract quickly, landing back in stance. The Back Kick: From stance, glance over your shoulder to spot your 'target' behind you. Lift your knee, drive your heel straight back. Keep your chest forward, core tight, and retract quickly.",
        workout: "3 Rounds (2 minutes each)\n30 sec Side Kicks (right leg)\n30 sec Side Kicks (left leg)\n30 sec Back Kicks (alternating legs)\n30 sec Side Kick + Back kick combo (Right Side kick + back kick, change to Left side kick + back kick)",
        formTip: "Balance builds power. Control creates confidence. Stay grounded, stay sharp, and trust your stance.",
        dailyWin: "Drop a ⚖️ for how you're feeling if you felt your balance get tested today … because tomorrow, we push the pace!",
        videoId: 'a40777b89bc4920ef1d52ed9f250997f',
        platform: 'cloudflare',
        focusAreas: ["Balance", "Precision", "Core Control"],
        equipment: ["None"],
        difficulty: "intermediate"
      },
      {
        day: 6,
        title: "DAY 6 – CARDIO FIGHT MOVES (ENDURANCE & GRIT)",
        movement: "Fight-Inspired Cardio",
        description: "You've built your stance. You've mastered punches, kicks, and defense.\n\nNow comes the test: can you keep moving when your heart's racing and your body's tired?\n\nThat's what fight cardio is all about … digging deep, finding grit, and proving to yourself you can outlast the round.",
        whyItMatters: "Cardio endurance is crucial for maintaining independence and energy throughout the day. These movements build the stamina you need for daily activities and help maintain heart health.",
        instructions: "Ground-to-Stand: Start standing tall. Drop all the way down to the ground (chest + hips touch). Pop back up to standing. Roll Jumps: From stance, squat + roll your torso down and around like drawing a 'U.' As you come up, explode into a vertical jump. 4 Jabs + 2 Knees Combo: Throw 4 quick jabs up top, then drive 2 rear knees through the middle. Speed Uppercuts: Guard up, knees soft. Rapid-fire alternating uppercuts, keeping them tight and fast.",
        workout: "3 Rounds (2 minutes each)\n30 sec Ground-to-Stand (jump or step)\n30 sec Roll Jumps (toe raise if needed)\n30 sec 4 Jabs + 2 Knees combo (go for speed & power!)\n30 sec Speed Uppercuts (GO FOR IT!!!)",
        formTip: "Endurance wins battles. It's not about the first punch … it's about still standing when the final bell rings. Pace yourself and listen to your body.",
        dailyWin: "Drop a 🔥 when you finish! Fight cardio is no joke. You're building the endurance to tackle anything life throws at you.",
        videoId: '6ee493f7b9fd2292641e640f1f72c151',
        platform: 'cloudflare',
        focusAreas: ["Cardio", "Endurance", "Mental Toughness"],
        equipment: ["None"],
        difficulty: "intermediate"
      },
      {
        day: 7,
        title: "DAY 7 – THE FINAL FIGHT ~ GRADUATION DAY",
        movement: "Complete Fight Flow",
        description: "You made it … the final day of Fight School. 👊\n\nAll week, you've built your fighter's foundation: stance, rotation, punches, defense, kicks, and cardio grit.\n\nNow it's time to put it ALL together in one full Fight Flow.\n\nThis is your graduation round … the moment you prove to yourself just how strong, skilled, and unstoppable you've become in only 7 days.",
        whyItMatters: "Putting it all together builds confidence and proves your progress. This final workout demonstrates how all the movements work together to create a complete fitness routine that builds strength, balance, and independence.",
        instructions: "Flow through all the movements you've learned this week. Start with jab-cross combos, add hooks and uppercuts, practice your defense, incorporate kicks, and finish with cardio moves. Focus on smooth transitions and maintaining your stance throughout.",
        workout: "3 Rounds (3 minutes each … just like a real fight round)\n30 sec Jab-Cross combo (Day 1)\n30 sec F Hook + R Uppercut (Day 2)\n30 sec R Slip + F Roll defense drill (Day 3)\n30 sec R Knees + F Front Kicks (Day 4)\n30 sec Side + Back Kicks - Alternating sides (Day 5)\n30 sec Jab + Knee combo (Day 6)",
        formTip: "Think of this as a dance. Smooth, controlled, and purposeful. You've graduated Fight School - carry this confidence into every part of your life.",
        dailyWin: "Drop a 🎓 when you finish! Tell me one word that describes how you feel after 7 days of Fight School … and celebrate this win. You've earned it.",
        videoId: '8fdb42fe6593f34d816a0f916621fc95',
        platform: 'cloudflare',
        focusAreas: ["Full Body", "Coordination", "Confidence"],
        equipment: ["None"],
        difficulty: "intermediate"
      }
    ],

    // WOW for Month 2
    workoutOfTheWeek: [
      {
        week: 1,
        title: "Strength Building Circuit",
        description: "Progressive strength training with added resistance",
        cloudflareStreamId: "d39afad8277362e560582c6d487c7b80",
        duration: 1800, // 30 minutes
        difficulty: "intermediate",
        focusAreas: ["Strength", "Power", "Endurance"],
        equipment: ["Dumbbells", "Resistance Band"]
      }
      // ... continue with 3 more weeks
    ],

    // Elite Guided Videos - Month 2 Fight School
    eliteGuidedVideos: {
      title: "Fight School - Elite Guided Videos",
      description: "Professional fight training with expert instruction for elite members",
      tier: "elite",
      videos: [
        {
          id: "fight-monday-combos",
          day: "Monday",
          title: "Fight Combos",
          description: "Master fundamental boxing combinations with proper form and technique",
          duration: 36.35, // minutes
          durationSeconds: 2181,
          displayDuration: "36:21",
          difficulty: "intermediate",
          focusAreas: ["Coordination", "Power", "Technique"],
          equipment: ["None", "Mirror"],
          videoId: "9fed032e52726114b8649755b0e98ed2",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762701282/1_un4mm7.png",
          exercises: [
            "Jab-Cross Combinations",
            "Hook-Uppercut Sequences", 
            "Defensive Movements",
            "Footwork Drills",
            "Power Development"
          ]
        },
        {
          id: "fight-tuesday-uppercut",
          day: "Tuesday", 
          title: "Uppercut Rounds",
          description: "Develop devastating uppercut power with proper technique",
          duration: 27.6667, // minutes
          durationSeconds: 1660,
          displayDuration: "27:40",
          difficulty: "intermediate",
          focusAreas: ["Power", "Core", "Technique"],
          equipment: ["None", "Mirror"],
          videoId: "aa98c89aa7cf9aea28acb3c18c600a60",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762701390/2_ztm1sx.png",
          exercises: [
            "Uppercut Form",
            "Power Development",
            "Core Engagement",
            "Combination Work",
            "Defensive Counters"
          ]
        },
        {
          id: "fight-wednesday-stance",
          day: "Wednesday",
          title: "Power Stance", 
          description: "Build unshakeable foundation with proper fighting stance",
          duration: 28.9333, // minutes
          durationSeconds: 1736,
          displayDuration: "28:56",
          difficulty: "intermediate",
          focusAreas: ["Balance", "Stability", "Power"],
          equipment: ["None", "Mirror"],
          videoId: "460c9af8bd3c4ead575d27502fb86bdd",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762701421/3_tkupne.png",
          exercises: [
            "Stance Fundamentals",
            "Balance Training",
            "Power Generation",
            "Movement Patterns",
            "Stability Drills"
          ]
        },
        {
          id: "fight-thursday-defense",
          day: "Thursday",
          title: "Defence Day",
          description: "Master defensive techniques and counter-attacks",
          duration: 19.35, // minutes
          durationSeconds: 1161,
          displayDuration: "19:21",
          difficulty: "intermediate", 
          focusAreas: ["Defense", "Reaction", "Counter-Attacks"],
          equipment: ["None", "Mirror"],
          videoId: "f31e097a04831fd34568974bd93619a5",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762701447/4_b963tl.png",
          exercises: [
            "Blocking Techniques",
            "Slipping Movements",
            "Counter-Attacks",
            "Reaction Drills",
            "Counter Combinations"
          ]
        },
        {
          id: "fight-friday-master",
          day: "Friday",
          title: "Fight Master",
          description: "Put it all together with advanced fight training",
          duration: 39.9833, // minutes
          durationSeconds: 2399,
          displayDuration: "39:59",
          difficulty: "advanced",
          focusAreas: ["Full Integration", "Advanced Techniques", "Fight Conditioning"],
          equipment: ["None", "Mirror"],
          videoId: "a14a689667e8e2bc4608a8ea3b9aaa62",
          platform: "cloudflare", 
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762701512/5_xihat0.png",
          exercises: [
            "Advanced Combinations",
            "Fight Conditioning",
            "Technique Integration",
            "Power Development",
            "Fight Simulation"
          ]
        }
      ]
    }
  },

  // Month 3 - Gratitude and Grit
  3: {
    month: 3,
    theme: "Gratitude and Grit",
    title: "Gratitude and Grit",
    description: "Build resilience, celebrate progress, and fuel every session with a grateful mindset. Month three blends strength, conditioning, and reflection so you finish each workout feeling powerful and grounded.",
    focusAreas: ["Strength", "Endurance", "Mindset"],
    difficulty: "intermediate",
    estimatedDuration: 35,
    dailyChallenge: [
      {
        day: 1,
        title: "DAY 1 – FIND YOUR FOUNDATION",
        movement: "Classic Forearm Plank",
        description: "Welcome to Planks & Thanks! Today we celebrate showing up by finding a strong, steady base that we can build on all week. This gentle core hold builds the midline support you rely on for everything from standing up out of a chair to walking confidently.",
        whyItMatters: "A solid plank teaches you how to create full-body tension, breathe under load, and trust your core to support you—skills that transfer to every other movement.",
        instructions: "Set up in a forearm plank with elbows under shoulders, ribs tucked, and glutes lightly engaged. Breathe in through the nose for three counts and out through the mouth for three.",
        workout: "3 rounds\n• 30-second forearm plank hold\n• 30-second rest\nFocus on quality and note your total time—use it as your baseline to beat on Day 7.",
        formTip: "Imagine drawing your elbows toward your toes to fire up the entire front side. Keep the back of your neck long and your gaze on the floor.",
        dailyWin: "Gratitude Prompt: What’s one thing—big or small—you’re truly thankful for right now? Write it down to anchor the week in appreciation.",
        videoId: '6b09d546796fe7a527ad25c821caae97',
        platform: 'cloudflare',
        focusAreas: ["Core", "Stability", "Endurance"],
        equipment: ["Mat", "Timer"],
        difficulty: "beginner"
      },
      {
        day: 2,
        title: "DAY 2 – BALANCE THROUGH CHANGE",
        movement: "Side Plank Hold",
        description: "Foundations set—now we explore stability when things tilt. Side planks teach your core and hips to steady you during everyday shifts, like stepping off a curb or reaching for a cupboard.",
        whyItMatters: "Lateral core strength supports your spine, hips, and balance in everyday twists, turns, and bracing when you stumble.",
        instructions: "Stack elbow under shoulder, extend legs, and lift hips into a straight line. Press the floor away and breathe steadily before switching sides.",
        workout: "2–3 rounds per side\n• 30–45-second side plank hold (right)\n• 15-second rest\n• 30–45-second side plank hold (left)\n• 45-second rest between rounds\nAdd gentle hip pulses in the final round if you feel stable.",
        formTip: "Keep hips stacked and lift from the bottom oblique—as if a string were pulling your underside waist up toward the sky.",
        dailyWin: "Gratitude Prompt: Who or what keeps you steady when life gets wobbly? Share it and tag your anchor.",
        videoId: 'b81ec2fcad1c3e5034bed69155bca1ed',
        platform: 'cloudflare',
        focusAreas: ["Core", "Balance", "Lateral Stability"],
        equipment: ["Mat"],
        difficulty: "beginner"
      },
      {
        day: 3,
        title: "DAY 3 – STAY STEADY IN MOTION",
        movement: "High Plank Shoulder Taps",
        description: "Time to hold strong while things shift. Shoulder taps challenge your posture and coordination so you can stay solid during daily tasks like carrying groceries or reaching overhead.",
        whyItMatters: "Learning to resist rotation builds a resilient core that protects your spine during reaching, carrying, and daily balance checks.",
        instructions: "Start in a high plank with feet slightly wider than hips. Tap opposite shoulders slowly without letting the hips sway side to side.",
        workout: "3 rounds\n• 40 seconds of alternating shoulder taps\n• 20 seconds rest\nFocus on quiet hips and controlled breathing.",
        formTip: "Press through the floor, squeeze glutes, and imagine balancing a glass of water on your low back—no spills allowed.",
        dailyWin: "Gratitude Prompt: What in your life is currently in motion that you can appreciate? Progress, even in transition, still counts.",
        videoId: 'ad4da02fe4651ad88d2e1f8886605add',
        platform: 'cloudflare',
        focusAreas: ["Core", "Anti-Rotation", "Coordination"],
        equipment: ["Mat"],
        difficulty: "intermediate"
      },
      {
        day: 4,
        title: "DAY 4 – DRIVE IT FORWARD",
        movement: "High Plank Knee Drives",
        description: "We’re halfway there. Today’s plank variation builds drive and endurance as you pull each knee in—perfect for keeping hips and core nimble enough to climb stairs or get in and out of the car.",
        whyItMatters: "Dynamic core work improves hip mobility, cardio capacity, and the mental grit to keep moving when fatigue appears.",
        instructions: "From a strong high plank, draw one knee toward the chest, pause, then switch sides with measured control. Keep hips level throughout.",
        workout: "3 rounds\n• 45 seconds alternating knee drives\n• 15 seconds rest\nOptional: Add a 60-second finisher round to test your pacing.",
        formTip: "Think slow and strong—not fast and frantic. Let breath guide the rhythm: inhale as the leg extends, exhale as you drive the knee in.",
        dailyWin: "Gratitude Prompt: Name a challenge that pushed you to grow stronger this year—and the lesson it taught you.",
        videoId: 'd9a82790d292306ec4a692212e8aeb58',
        platform: 'cloudflare',
        focusAreas: ["Core", "Hip Mobility", "Cardio"],
        equipment: ["Mat"],
        difficulty: "intermediate"
      },
      {
        day: 5,
        title: "DAY 5 – FLIP YOUR PERSPECTIVE",
        movement: "Reverse Tabletop Hold",
        description: "A new angle for a fresh outlook. Reverse planks fire up the back of the body so sitting tall, supporting your shoulders, and maintaining upright posture feel easier throughout the day.",
        whyItMatters: "Strengthening the posterior chain improves posture, shoulder health, and overall stability for daily lifting and reaching.",
        instructions: "Sit tall with legs extended and hands planted behind you. Press through heels and palms, lifting hips until your body forms a straight line.",
        workout: "3 rounds\n• 45–60-second reverse tabletop hold\n• 30 seconds rest between rounds\nEase into the hold and focus on full-body tension.",
        formTip: "Drive knees toward each other, squeeze glutes, and keep chest proud to avoid collapsing through the shoulders.",
        dailyWin: "Gratitude Prompt: Who or what helped you see life from a different perspective this year? Share a thank-you.",
        videoId: '2bb54fc91bd9e4e45cf17bc4409d93d0',
        platform: 'cloudflare',
        focusAreas: ["Posterior Chain", "Shoulders", "Core"],
        equipment: ["Mat"],
        difficulty: "intermediate"
      },
      {
        day: 6,
        title: "DAY 6 – STRENGTH IN TRANSITION",
        movement: "Walking Planks",
        description: "Transitions test patience and control. Today’s walking planks reinforce your ability to move up and down with intention—just like getting down to play with grandkids and standing back up safely.",
        whyItMatters: "Pressing from forearms to hands strengthens shoulders and triceps while training the core to stay solid through changing positions.",
        instructions: "Begin in a forearm plank, press up to a high plank one hand at a time, then lower back down—alternating the lead arm each rep.",
        workout: "3 rounds\n• 45–60 seconds of walking planks\n• 20 seconds rest\nMove slowly, keep hips level, and stay mindful of alignment.",
        formTip: "Plant hands under shoulders, engage glutes, and keep steps quiet to avoid rocking side to side.",
        dailyWin: "Gratitude Prompt: What transition are you navigating right now, and what in it are you thankful for?",
        videoId: '385d44d784cb7d369ab8f727c44118f9',
        platform: 'cloudflare',
        focusAreas: ["Core", "Shoulders", "Endurance"],
        equipment: ["Mat"],
        difficulty: "intermediate"
      },
      {
        day: 7,
        title: "DAY 7 – FINISH WITH GRATITUDE & GRIT",
        movement: "Endurance Plank Test",
        description: "You made it! Today is your opportunity to celebrate progress by beating your Day 1 plank time and closing the challenge with pride. This simple hold reminds you that core strength supports balance, stamina, and confidence in every daily move.",
        whyItMatters: "Endurance work showcases how far you’ve come—physically and mentally—by maintaining control under fatigue.",
        instructions: "Choose forearm or high plank. Set a timer and hold with perfect form for as long as possible, resting only when alignment slips.",
        workout: "1 round\n• Max plank hold (forearm or high)\nGoal: Beat your combined Day 1 total time. Record your result and celebrate the win.",
        formTip: "Stack joints, brace the entire core, and breathe deeply. Whisper the words “I. DID. THAT.” the moment you finish.",
        dailyWin: "Gratitude Prompt: List three things you’re grateful for after completing this challenge—and one new capability you now believe in.",
        videoId: '57bbb701862ce58fda73edf05e556dbb',
        platform: 'cloudflare',
        focusAreas: ["Core", "Mental Resilience", "Endurance"],
        equipment: ["Mat", "Timer"],
        difficulty: "all levels"
      }
    ],

    // Workout of the Week (WOW) - 4 weeks
    workoutOfTheWeek: [
      {
        week: 1,
        title: "Uppercut Rounds",
        description: "Build your foundation with strength and resilience",
        cloudflareStreamId: "2e2c545e3b773b735724aabe6a43109f",
        duration: 1800, // 30 minutes
        difficulty: "intermediate",
        focusAreas: ["Strength", "Endurance", "Foundation"],
        equipment: ["Dumbbells", "Mat"]
      },
      {
        week: 2,
        title: "Kickstart Your Engine",
        description: "Progressive strength training with added intensity",
        cloudflareStreamId: "fd98a280915074c73b64f032c5797cab",
        duration: 1800, // 30 minutes
        difficulty: "intermediate",
        focusAreas: ["Strength", "Power", "Endurance"],
        equipment: ["Dumbbells", "Resistance Band"]
      },
      {
        week: 3,
        title: "Endurance Test",
        description: "Advanced movements to test your grit and determination",
        cloudflareStreamId: "7b5492ec9e2b3aecf34a712f4b66e473",
        duration: 2100, // 35 minutes
        difficulty: "intermediate",
        focusAreas: ["Full Body", "Endurance", "Mental Resilience"],
        equipment: ["Dumbbells", "Mat"]
      },
      {
        week: 4,
        title: "Fight Combos",
        description: "Put it all together with a comprehensive full-body challenge",
        cloudflareStreamId: "27f624e7b36dfec745b5f238e5dbce04",
        duration: 2100, // 35 minutes
        difficulty: "intermediate",
        focusAreas: ["Full Body", "Endurance", "Integration"],
        equipment: ["Dumbbells", "Resistance Band", "Mat"]
      }
    ],

    eliteGuidedVideos: {
      title: "Gratitude and Grit - Elite Guided Videos",
      description: "Kick up the intensity while staying grounded in gratitude. These sessions layer controlled strength, core stability, and sustainable cardio so you finish energized—not drained.",
      tier: "elite",
      videos: [
        {
          id: "grit-monday-engine",
          day: "Monday",
          title: "Kickstart Your Engine",
          description: "Dynamic full-body primer that wakes up hips, shoulders, and breath control for the week ahead.",
          duration: 36.0333,
          durationSeconds: 2162,
          displayDuration: "36:02",
          difficulty: "intermediate",
          focusAreas: ["Warm-Up", "Mobility", "Cardio"],
          equipment: ["Light Dumbbells", "Mat"],
          videoId: "ddefc2e8f94af6acae0e3f5b5dd420b0",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762729661/1_vzdkyp.png",
          exercises: [
            "Mobility-driven warm-up flow",
            "Controlled tempo strength sets",
            "Low-impact cardio finishers"
          ]
        },
        {
          id: "grit-tuesday-upper",
          day: "Tuesday",
          title: "Upper Rep Burn",
          description: "Slow-tempo upper-body sequences that build muscular endurance without stressing joints.",
          duration: 36.9167,
          durationSeconds: 2215,
          displayDuration: "36:55",
          difficulty: "intermediate",
          focusAreas: ["Upper Body", "Endurance", "Slow Strength"],
          equipment: ["Light Dumbbells", "Chair"],
          videoId: "f3f4b3e6f9bb254a1f8e92c7a5d549a0",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762729661/2_oo93eh.png",
          exercises: [
            "Tempo shoulder presses",
            "Wall-supported rows",
            "Isometric finisher for posture"
          ]
        },
        {
          id: "grit-wednesday-core",
          day: "Wednesday",
          title: "Core For Days",
          description: "Anti-rotation and balance drills to bulletproof the core and protect the spine.",
          duration: 20.45,
          durationSeconds: 1227,
          displayDuration: "20:27",
          difficulty: "intermediate",
          focusAreas: ["Core", "Balance", "Stability"],
          equipment: ["Mat", "Mini Band"],
          videoId: "398091e461285110501089aee92b6368",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762729661/3_v4psdb.png",
          exercises: [
            "Band-resisted dead bug variations",
            "Tall-kneeling anti-rotation holds",
            "Balance-focused finisher"
          ]
        },
        {
          id: "grit-thursday-recover",
          day: "Thursday",
          title: "Reps and Recover",
          description: "Alternating strength and restorative mobility so joints stay calm while muscles work hard.",
          duration: 16.9167,
          durationSeconds: 1015,
          displayDuration: "16:55",
          difficulty: "all levels",
          focusAreas: ["Mobility", "Active Recovery", "Strength"],
          equipment: ["Chair", "Light Dumbbells"],
          videoId: "30221ccfd6adb1c84de089330b8a5537",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762729661/4_w47p8t.png",
          exercises: [
            "Superset strength intervals",
            "Stretch-focused cooldown",
            "Breath-led nervous system reset"
          ]
        },
        {
          id: "grit-friday-throttle",
          day: "Friday",
          title: "Full Throttle Endurance Test",
          description: "Progressive cardio ladder that challenges stamina while keeping movements joint-safe.",
          duration: 23.3333,
          durationSeconds: 1400,
          displayDuration: "23:20",
          difficulty: "intermediate",
          focusAreas: ["Cardio", "Endurance", "Mental Toughness"],
          equipment: ["None"],
          videoId: "6acf1ad033d2157afa994505380a5eed",
          platform: "cloudflare",
          thumbnailUrl: "https://res.cloudinary.com/dpy2y99bz/image/upload/v1762729661/5_mdxqie.png",
          exercises: [
            "Low-impact cardio ladder",
            "Recovery blocks with breathwork",
            "Gratitude reflection cooldown"
          ]
        }
      ]
    }
  }
};

// Helper functions
export const getMonthlyWorkouts = (month) => {
  return monthlyWorkouts[month] || null;
};

export const getAllMonthlyWorkouts = () => {
  return monthlyWorkouts;
};

export const getWorkoutOfWeek = (month, week) => {
  const monthlyData = monthlyWorkouts[month];
  if (!monthlyData || !monthlyData.workoutOfTheWeek) return null;
  return monthlyData.workoutOfTheWeek.find(w => w.week === week);
};

export const getDailyChallenge = (month, day) => {
  const monthlyData = monthlyWorkouts[month];
  if (!monthlyData || !monthlyData.dailyChallenge) return null;
  return monthlyData.dailyChallenge.find(d => d.day === day);
};

export const getMonthlyChallenge = (month) => {
  const monthlyData = monthlyWorkouts[month];
  return monthlyData?.monthlyChallenge || null;
};

export const getEliteGuidedVideos = (month) => {
  const monthlyData = monthlyWorkouts[month];
  return monthlyData?.eliteGuidedVideos || null;
};

export const getEliteGuidedVideo = (month, videoId) => {
  const eliteVideos = getEliteGuidedVideos(month);
  if (!eliteVideos || !eliteVideos.videos) return null;
  return eliteVideos.videos.find(video => video.id === videoId);
};

export default monthlyWorkouts;
